import { useRouter } from "next/router";
import { useState, useRef, useEffect, useContext } from "react";
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import { Document, Page, pdfjs } from "react-pdf";
import { statesOfUSA } from "../../../../constants/contracts";
import { AiOutlineClose } from "react-icons/ai";
import styles from "../contract.module.css";
import {
  BASE_ASSETS_URL,
  BASE_URL,
  BASE_URL_POST,
  SIGNATURE_BASE_URL,
  SIGNATURE_PAYMENTS_BASE_URL,
} from "../../../../constants/constants";
import { FaSignature } from "react-icons/fa";
import { BsDownload } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import MixPanel from "../../../../utils/mixpanel";
import AppContext from "../../../../components/AppContext";
import {
  BsFillArrowRightSquareFill,
  BsArrowLeftSquareFill,
} from "react-icons/bs";
import { createUTMQueryParams } from "@utils/signature_owner";
import { legalTemplatesMapping } from "../../../../constants/contracts";
import { BiPencil } from "react-icons/bi";
import { CLMButtonPrimary, CLMButtonPrimary1 } from "components/CLM/v3/Buttons";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const addHyphenInUrl = (str) => {
  return str.replace(/\s+/g, "-").toLowerCase();
};

export async function getServerSideProps(context) {
  const { contract, category } = context.query;
  const response = await fetch(`${BASE_URL}single-contract/${contract}`);
  const data = await response.json();
  // console.log(data)
  const { contractData, relatedContracts } = data;
  // console.log(contractData);
  return {
    props: {
      contractData: contractData,
      relatedContracts: relatedContracts,
    },
  };
}

const Contract = ({ contractData, relatedContracts }) => {
  const router = useRouter();
  const { contract, category } = router.query;
  const context = useContext(AppContext);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);

  const [clickedButton, setClickedButton] = useState(null);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [showBoloformsModal, setShowBoloformsModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [sticyButtonVisible, setSticyButtonVisible] = useState(false);
  const [isLegalTemplate, setIsLegalTemplate] = useState(false);
  const htmlElement = useRef(null);
  const emailToggler = useRef(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const nextPage = (pageNumber) => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const previousPage = (pageNumber) => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const downloadAsPdf = async () => {
    let newEl = document.createElement("a");
    newEl.href = contractData?.pdfLink;
    newEl.target = "_self";
    newEl.download = contractData?.contract_name;
    newEl.click();
  };

  const downloadAsDoc = async () => {
    let newEl = document.createElement("a");
    newEl.href = contractData?.docLink;
    newEl.download = contractData?.contract_name;
    newEl.click();
  };

  const validateEmail = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleBlur = () => {
    validateEmail();
  };

  useEffect(() => {
    // console.log("=========contractData=========", contractData);
    if (typeof window !== "undefined") {
      updateScreenSize();
      window.addEventListener("resize", updateScreenSize);

      return () => {
        window.removeEventListener("resize", updateScreenSize);
      };
    }
  }, []);

  useEffect(() => {
    console.log("checking for legal template");
    if (legalTemplatesMapping[contract]) {
      setIsLegalTemplate(true);
    } else {
      setIsLegalTemplate(false);
    }
  }, [contract]);

  const handleExport = async (exportType, newSubscriber) => {
    validateEmail();

    if (emailError) {
      return;
    }

    if (newSubscriber) {
      if (email === "") {
        return;
      }
      setDownloadLoading(true);
      localStorage.setItem("BoloformsEmail", email);
      const subscribeEmail = await fetch(`${BASE_URL_POST}subscribe-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }), // Replace with your data
      });
      // console.log(subscribeEmail);

      const saveOwner = await fetch(`${SIGNATURE_BASE_URL}/owners`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, from: "CONTRACTS" }),
      });

      if (exportType === "Pdf") {
        // downloadAsPdf();
        if (isLegalTemplate) {
          window.open(
            `https://formlocator.net/?template_id=${
              legalTemplatesMapping[contractData?.slug]
            }`,

            "_blank"
          );
        } else {
          router.push(
            `/signature/download-success?category=${category}&contract_name=${contractData?.name}&pdfLink=${contractData?.pdfLink}`
          );
        }
      }
      if (exportType === "Doc") {
        router.push(
          `/signature/download-success?category=${category}&contract_name=${contractData?.name}&pdfLink=${contractData?.pdfLink}`
        );
        // downloadAsDoc();
      }
      setDownloadLoading(false);
      closeEmailPrompt();
      setShowBoloformsModal(true);
      return;
    }
    if (!newSubscriber) {
      if (isLegalTemplate) {
        window.open(
          `https://formlocator.net/?template_id=${
            legalTemplatesMapping[contractData?.slug]
          }`,

          "_blank"
        );
      } else {
        router.push(
          `/signature/download-success?category=${category}&contract_name=${contractData?.name}&pdfLink=${contractData?.pdfLink}`
        );
      }
      // await downloadAsPdf();

      if (exportType === "Doc") {
        router.push(
          `/signature/download-success?category=${category}&contract_name=${contractData?.name}&pdfLink=${contractData?.pdfLink}`
        );
        // await downloadAsDoc();
      }
      setShowBoloformsModal(true);
      return;
    }
  };

  const openEmailPrompt = (promptType) => {
    if (typeof window !== undefined) {
      const storedEmail = localStorage.getItem("BoloformsEmail");
      if (!storedEmail) {
        setClickedButton(promptType);
        emailToggler.current.classList.toggle("hidden");
        return;
      } else {
        setEmail(storedEmail);
        handleExport(promptType, false);
        return;
      }
    }
  };

  const closeEmailPrompt = () => {
    emailToggler.current.classList.toggle("hidden");
    return;
  };

  const [screenSize, setScreenSize] = useState({ width: 0, height: 0 });

  const updateScreenSize = () => {
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const handleScroll = () => {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > 800) {
      setSticyButtonVisible(true);
    } else {
      setSticyButtonVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="w-full  mt-8">
      <Head>
        <meta charSet="utf-8" />
        <title>{contractData?.metaTitle} | BoloForms</title>

        <meta name="description" content={`${contractData?.metaDescription}`} />

        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="BoloSign" />
        <meta name="publisher" content="BoloSign" />
        <meta name="keywords" content={`${contractData?.metaKeywords}`} />
        <meta
          property="og:url"
          content={`https://www.bolosign.com/signature/contracts/${addHyphenInUrl(
            contractData?.categories
          )}/${contractData?.slug}/`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`${contractData?.metaTitle} | BoloSign`}
        />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content={`https://www.bolosign.com/signature/contracts/${addHyphenInUrl(
            contractData?.categories
          )}/${contractData?.slug}/`}
        />
        <meta
          name="twitter:title"
          content={`${contractData?.metaTitle} | BoloSign`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@boloforms" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          name="twitter:description"
          content={`${contractData?.metaDescription}`}
        />
        <meta
          property="og:description"
          content={`${contractData?.metaDescription}`}
        />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          content={`https://www.bolosign.com/signature/contracts/${addHyphenInUrl(
            contractData?.categories
          )}/${contractData?.slug}/`}
        />
      </Head>

      <div
        ref={emailToggler}
        className="fixed w-full h-[100vh] bg-gray-800/80 left-0 top-0 z-[2000] flex justify-center items-center p-5 hidden"
      >
        <div className="max-w-[700px] p-8 md:py-10 md:px-20 bg-white rounded-3xl text-gray-700 flex gap-3 md:gap-7 flex-col justify-between items-center relative">
          <div
            onClick={() => {
              setEmailError("");
              setEmail("");
              closeEmailPrompt();
            }}
            className="md:w-[50px] md:h-[50px] bg-white/60 border border-violet-800 rounded-full close absolute top-[-10px] right-[-10px] md:top-[-20px] md:right-[-20px] text-violet-600 text-4xl font-bold cursor-pointer hover:text-red-500 grid place-items-center"
          >
            <AiOutlineClose />
          </div>
          <h1 className="text-xl md:text-3xl">
            Download{" "}
            <span className="text-violet-600">
              {contractData?.secondaryName}
            </span>{" "}
            {clickedButton}
          </h1>
          <div className="w-full flex flex-col gap-3">
            <div className="text-gray-600 font-bold text-lg">Your Email</div>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={handleBlur}
              className="w-full h-[60px] rounded-full border px-8 outline-none"
              type="email"
              placeholder="myemail@gmail.com"
              name=""
              id=""
            />
            {emailError && (
              <div className="text-red-400 font-bold">{emailError}</div>
            )}
            {downloadLoading ? (
              <div
                className={`ml-[20px] flex items-center mt-5 text-gray-600 space-x-2 ${styles.loader}`}
              >
                <div className="text-violet-600">Downloading</div>
                <div className="w-2 h-2 bg-violet-600 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-violet-600 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-violet-600 rounded-full animate-bounce"></div>
              </div>
            ) : (
              <div className="text-gray-600 mt-5">
                Download your template as a {clickedButton} file.
              </div>
            )}
            <button
              onClick={() => handleExport(clickedButton, true)}
              className="w-full bg-violet-600 text-white text-xl py-4 rounded-full hover:opacity-90"
            >
              Download {clickedButton}
            </button>
          </div>
        </div>
      </div>

      {showBoloformsModal && (
        <div
          className={`fixed z-[1000] top-0 left-0 w-full flex justify-center items-start px-[5px] py-[100px] bg-white/60 min-h-screen`}
        >
          <div className="relative flex flex-col md:flex-row justify-center items-center w-fit bg-violet-500 rounded-2xl mx-2">
            <div
              onClick={() => setShowBoloformsModal(false)}
              className="border border-b-none border-violet-300 shadow-xl absolute top-[-25px] left-[50%] -translate-x-[50%] w-[50px] h-[50px] hover:opacity-90 rounded-full cursor-pointer grid place-items-center bg-white text-violet-600 font-bold text-[20px]"
            >
              <AiOutlineClose className="font-bold" />
            </div>
            <div className="lg:w-[500px] md:h-[250px] lg:h-[250px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]">
              <div className="text-[25px] font-semibold">
                Do you want to send this for signature?
              </div>
              <div className="self-center">
                <Link
                  target="_blank"
                  href={`https://signature.boloforms.com/login?from=${
                    context.globalData.from || "CONTRACTS"
                  }${createUTMQueryParams({
                    utmData_: context.globalData.utmData,
                    from: "CONTRACTS",
                  })}`}
                  className="bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80"
                >
                  Get started for Free
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/*   NO NEED TO ADD HERE SINCE IT IS FLOATING TYPE */}
      {sticyButtonVisible &&
        (legalTemplatesMapping[contractData?.slug] ? (
          <CLMButtonPrimary
            buttonText="Create Document"
            buttonUrl={`https://formlocator.net/?template_id=${
              legalTemplatesMapping[contractData?.slug]
            }`}
            rel="nofollow noreferrer noopener"
            newTab={true}
            icon={<BiPencil />}
          />
        ) : (
          <CLMButtonPrimary1
            buttonText={"Create Document"}
            icon={<BiPencil />}
            onClick={() => {
              new MixPanel().track("Contracts", {
                billing_action: "contract_click_download",
                contract: contractData?.name,
              });
              setShowDownloadModal((prev) => !prev);
            }}
          />
        ))}

      <div className="max-w-screen-xl mx-auto flex flex-col scroll-smooth px-4 lg:px-8 ">
        {/* contract nav section */}
        <div className="flex flex-wrap items-center gap-2 text-gray-900 text-md mb-5">
          <Link className="hover:text-violet-600" href="/signature/contracts">
            Home
          </Link>
          <span className="">{`>`}</span>
          <Link
            className="hover:text-violet-700"
            href={`/signature/contracts/${addHyphenInUrl(
              contractData?.categories
            )}`}
          >
            {contractData?.categories}
          </Link>
          <span className="">{`>`}</span>
          <p>{contractData?.name}</p>
        </div>

        {/* main section */}
        <div className="flex flex-col-reverse xl:flex-row justify-between gap-10">
          {/* left section */}
          <div className="flex flex-col gap-10 flex-1">
            {/* heading section */}
            <div className="flex flex-col gap-5">
              <h1
                style={{ lineHeight: 1.2 }}
                className="text-3xl sm:text-5xl text-black"
              >
                Download {contractData?.secondaryName}
              </h1>
              <p className="text-xl text-gray-900">
                {contractData?.secondaryDescription}
              </p>
              <div className="flex flex-col gap-3 sm:gap-0 sm:flex-row sm:items-center">
                {legalTemplatesMapping[contractData?.slug] ? (
                  <CLMButtonPrimary
                    buttonText="Create Document"
                    buttonUrl={`https://formlocator.net/?template_id=${
                      legalTemplatesMapping[contractData?.slug]
                    }`}
                    rel="nofollow noreferrer noopener"
                    newTab={true}
                    icon={<BiPencil />}
                  />
                ) : (
                  <CLMButtonPrimary1
                    buttonText={"Create Document"}
                    icon={<BiPencil />}
                    onClick={() => {
                      new MixPanel().track("Contracts", {
                        billing_action: "contract_click_download",
                        contract: contractData?.name,
                      });
                      setShowDownloadModal((prev) => !prev);
                    }}
                  />
                )}
              </div>
            </div>
            {isLegalTemplate && (
              <div className="flex -mt-6 text-[12px]">
                Powered by{" "}
                <Image
                  className="mx-2"
                  src={`${BASE_ASSETS_URL}/legal-templates.ico`}
                  alt="LegalTemplates"
                  width={20}
                  height={15}
                />
                LegalTemplates.
              </div>
            )}
            {/* content section */}
            {contractData?.hasState === "TRUE" && (
              <div className="flex flex-col gap-3">
                <p className="text-gray-900 text-xl">
                  Select your state below to find a{" "}
                  {contractData?.secondaryName}
                </p>
                <div className="flex w-fit items-center flex-wrap p-8 border border-gray-700 rounded-xl">
                  {statesOfUSA.map((state, index) => (
                    <div key={index} className="md:w-1/5 sm:w-1/3 w-1/2 mb-3">
                      <Link
                        className=""
                        href={`/signature/contracts/${addHyphenInUrl(
                          contractData?.categories
                        )}/${contractData?.slug}/${addHyphenInUrl(
                          state.label
                        )}`}
                      >
                        <p className="underline text-[14px] text-gray-900 hover:text-violet-500">
                          {state.label}
                        </p>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div
              className={`contract-data flex flex-col`}
              dangerouslySetInnerHTML={{ __html: contractData?.content }}
            ></div>
            {/* pdf section */}
            <div
              title={`Download ${contractData?.secondaryName} PDF`}
              className="w-full pdf-preview"
              id={`preview-${addHyphenInUrl(contractData?.name)}`}
            >
              <Document
                className="border border-gray-700 w-fit mx-auto"
                file={`${contractData?.pdfLink}`}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page
                  width={screenSize.width < 800 ? screenSize.width - 80 : 700}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  pageNumber={pageNumber}
                />
              </Document>
              <div className="mt-5 flex gap-5 items-center justify-center">
                <div className="flex gap-2 items-center">
                  <button
                    className="bg-white text-3xl hover:opacity-90 text-black text-center"
                    onClick={() => previousPage(pageNumber)}
                  >
                    {""} <BsArrowLeftSquareFill />
                  </button>
                  <p className="">
                    Page {pageNumber} of {numPages}
                  </p>
                  <button
                    className="bg-white text-3xl hover:opacity-90 text-black text-center"
                    onClick={() => nextPage(pageNumber)}
                  >
                    {/* Next{""} */}
                    <BsFillArrowRightSquareFill />
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <div className="text-4xl font-semibold text-black">
                Related {contractData?.subcategories} Contracts
              </div>
              <ul className="flex flex-col gap-3 mt-5 list-disc ml-10 mxl:ml-0">
                {relatedContracts?.map((contract, index) => (
                  <li key={index} className="text-lg text-gray-900">
                    <Link
                      href={`/signature/contracts/${addHyphenInUrl(
                        contractData?.categories
                      )}/${contract?.slug}`}
                      className="hover:text-violet-500 underline font-semibold"
                    >
                      {contract?.name}
                    </Link>{" "}
                    : {contract?.secondaryDescription}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* right section */}
          <div
            title={`Download ${contractData?.secondaryName} PDF`}
            className={`flex justify-between items-center mx-auto flex-col pdf-container border border-gray-400 rounded-lg   p-5 xl:sticky top-[120px]`}
          >
            <Document
              className="border w-fit my-auto mb-3"
              file={`${contractData?.pdfLink}`}
            >
              <Page
                width={screenSize.width < 425 ? screenSize.width - 100 : 340}
                pageNumber={1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
            {/* <Link
              className="w-full sm:w-[340px] mx-auto xl:w-full"
              href={`#preview-${addHyphenInUrl(contractData?.name)}`}
            > */}
            {legalTemplatesMapping[contractData?.slug] ? (
              <CLMButtonPrimary
                buttonText="Create Document"
                buttonUrl={`https://formlocator.net/?template_id=${
                  legalTemplatesMapping[contractData?.slug]
                }`}
                rel="nofollow noreferrer noopener"
                newTab={true}
                icon={<BiPencil />}
              />
            ) : (
              <CLMButtonPrimary1
                buttonText={"Create Document"}
                icon={<BiPencil />}
                onClick={() => {
                  new MixPanel().track("Contracts", {
                    billing_action: "contract_click_download",
                    contract: contractData?.name,
                  });
                  setShowDownloadModal((prev) => !prev);
                }}
              />
            )}

            {isLegalTemplate && (
              <div className="flex mt-2 text-[12px]">
                Powered by{" "}
                <Image
                  className="mx-2"
                  src={`${BASE_ASSETS_URL}/legal-templates.ico`}
                  alt="LegalTemplates"
                  width={20}
                  height={15}
                />
                LegalTemplates.
              </div>
            )}
          </div>
        </div>
      </div>

      {showDownloadModal && (
        <DownloadContractModal
          contractData={contractData}
          contract={contract}
          setShowDownloadModal={setShowDownloadModal}
        />
      )}

      <ToastContainer
        className={`text-xs`}
        // theme="dark"
        position="bottom-right"
      />
    </div>
  );
};

export default Contract;

const DownloadContractModal = ({
  contractData,
  contract,
  setShowDownloadModal,
}) => {
  const router = useRouter();
  const [email, setEmail] = useState(localStorage.getItem("BoloformsEmail"));

  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    return emailRegex.test(email);
  };

  const checkForLegalTemplate = () => {
    console.log(
      "legalTemplatesMapping",
      contractData?.slug,
      legalTemplatesMapping[contractData?.slug]
    );
    if (legalTemplatesMapping[contractData?.slug]) {
      return true;
    }
    return false;
  };

  const handleDownload = async (type) => {
    try {
      let isNewSubscriber = !localStorage.getItem("BoloformsEmail");

      if (typeof window !== undefined) {
        if (!validateEmail(email)) {
          return toast.error("Please enter a valid email address");
        } else {
          if (isNewSubscriber) {
            // console.log("New Subscriber");
            const subscribeEmail = await fetch(
              `${BASE_URL_POST}subscribe-email`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: email }), // Replace with your data
              }
            );
            // console.log(subscribeEmail);

            const saveOwner = await fetch(`${SIGNATURE_BASE_URL}/owners`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email: email, from: "CONTRACTS" }),
            });

            localStorage.setItem("BoloformsEmail", email);
          }

          if (type === "free") {
            // let newEl = document.createElement("a");
            // newEl.href = contractData?.pdfLink;
            // newEl.target = "_self";
            // newEl.download = contractData?.contract_name;
            // newEl.click();

            new MixPanel().track("Contracts", {
              billing_action: "contract_click_download_free",
              contract: contractData?.name,
            });
            new MixPanel().increment("contract_click_download_free");
            // console.log("legalTemplatesMapping", legalTemplatesMapping);
            if (checkForLegalTemplate()) {
              // redirect to legal template
              window.open(
                `https://formlocator.net/?template_id=${
                  legalTemplatesMapping[contractData?.slug]
                }`,

                "_blank"
              );
            } else {
              router.push(
                `/signature/contracts/download-success?category=${addHyphenInUrl(
                  contractData?.categories
                )}&contract_name=${contractData?.name}&pdfLink=${
                  contractData?.pdfLink
                }&utm_source=${contractData?.name}`
              );
            }
          }

          if (type === "paid") {
            let paymentDetails = await fetch(
              `${SIGNATURE_PAYMENTS_BASE_URL}/createStripeOneTimePaymentUS`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  priceId: "price_1OxNZ0LiGbRu8waGVSTwEeCe",
                  quantity: 1,
                  ownerEmail: email,
                  cancelUrl: window.location.href,
                  successUrl: `https://www.boloforms.com/pdf-editor/?pdfUrl=${contractData?.pdfLink}&contract=${contract}&whichFlow=DOWNLOAD&isPaid=true`,
                }),
              }
            );
            paymentDetails = await paymentDetails.json();
            console.log("paymentDetails", paymentDetails);
            window.open(paymentDetails?.sessionUrl, "_self");

            new MixPanel().track("Contracts", {
              billing_action: "contract_click_download_payment_started",
              contract: contractData?.name,
            });
            new MixPanel().increment("contract_click_download_payment_started");
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="fixed w-full h-[100vh] bg-gray-800/80 left-0 top-0 z-[2000] flex justify-center items-center p-5">
      <div className="max-w-[700px] px-8 py-12 md:px-20 bg-white rounded-3xl text-gray-700 flex gap-3 md:gap-7 flex-col justify-between items-center relative">
        <MdClose
          onClick={() => setShowDownloadModal((prev) => !prev)}
          className="absolute top-5 right-5 text-2xl cursor-pointer imageBorders"
        />

        <div>
          <h1 className="text-base md:text-3xl text-black">
            Please provide your email
          </h1>
          <p className="text-gray-900 mt-3 text-xs md:text-base">
            Create your contract for free.
          </p>
        </div>

        <div className="w-full mt-3 md:mt-0">
          <p className="text-gray-900 font-bold text-xs md:text-sm mb-1">
            Your Email
          </p>
          <input
            className="w-full py-2.5 md:py-3 text-gray-800 rounded-md border-2 px-4 outline-none text-sm md:text-base border-gray-700 placeholder-gray-800"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="w-full flex flex-col gap-3">
          {/* <button
            onClick={() => handleDownload("free")}
            className="w-full text-violet-500 bg-white rounded-md border-2 border-violet-500 font-bold text-sm md:text-base py-3 hover:opacity-90"
          >
            Download with watermark (Free)
          </button> */}
          <button
            onClick={() => handleDownload("free")}
            className="w-full bg-black text-white rounded-md border-2 border-black font-bold text-sm md:text-base py-3 transition-all duration-500 ease-in-out hover:bg-black/90 hover:border-black"
          >
            Create Now
          </button>
        </div>
      </div>
      <ToastContainer
        className={`text-xs`}
        // theme="dark"
        position="bottom-right"
      />
    </div>
  );
};
